/**
 * Derives a root group path from a customer domain by reversing the
 * dot-separated segments (e.g. "acme.com" → "com.acme").
 */
export function deriveRootGroup(domain: string): string {
  const trimmed = domain.trim().toLowerCase();
  if (!trimmed) {
    return '';
  }
  return trimmed.split('.').reverse().join('.');
}
